import { BigNumber } from 'bignumber.js'

// Randomly generate a number based on min and max
export function getRandom (min: number, max: number) {
  let r = Math.random() * (max - min)
  let re = Math.round(r + min)
  re = Math.max(Math.min(re, max), min)
  return re
}

// Ascending:asc   Descending:des
export function compare(propertyName: string, type: string = 'asc', isStr?: boolean) {
  return function(object1: any, object2: any) {
    const value1 = isStr ? object1[propertyName] : +object1[propertyName]
    const value2 = isStr ? object2[propertyName] : +object2[propertyName]
    if (value2 < value1) {
      return type === 'des' ? -1 : 1
    } else if (value2 > value1) {
      return type === 'des' ? 1 : -1
    } else {
      return 0
    }
  }
}

export function stopPropagation(e: any) {
  if (e.stopPropagation) {
    // 针对 Mozilla 和 Opera
    e.stopPropagation()
  } else if (window.event) {
    // 针对 IE
    window.event.cancelBubble = true
  }
}

export const getVideoBase64 = async (url: string) => {
  let cover = await new Promise((resolve, reject) => {
    let dataURL = '';
    let video = document.createElement("video");
    // video.setAttribute('crossOrigin', 'anonymous');//处理跨域
    video.setAttribute('src', url);
    video.setAttribute('width', '400');
    video.setAttribute('height', '240');
    video.addEventListener('loadeddata', function () {
      let canvas: any = document.createElement("canvas"),
      width = video.width, //canvas的尺寸和图片一样
      height = video.height;
      canvas.width = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(video, 0, 0, width, height); //绘制canvas
      dataURL = canvas.toDataURL('image/jpeg'); //转换为base64
      resolve(dataURL)
    })
  })
  return cover
}

// get pet image url
const PET_FEATURES_LEN = 4
const PET_TYPE_LIMIT = 3
const WEAPON_TYPE_LIMIT = 4
const WEAPON_LEVEL_LIMIT = 11
const HELMET_TYPE_LIMIT = 4
const HELMET_LEVEL_LIMIT = 7
interface getPetImageUrlProps {
  petType: number,
  weaponType: number | string
  weaponLevel: number | string
  helmetType: number | string
  helmetLevel: number | string
}
export function getPetImageUrl({
  petType,
  weaponType,
  weaponLevel,
  helmetType,
  helmetLevel
}: getPetImageUrlProps) {
  const petTypeStr = new BigNumber(petType)
    .minus(1)
    .mod(PET_TYPE_LIMIT)
    .integerValue()
    .toString(2)
  const weaponTypeStr = new BigNumber(weaponType)
    .mod(WEAPON_TYPE_LIMIT)
    .integerValue()
    .toString(2)
  const weaponLevelStr = new BigNumber(weaponLevel)
    .mod(WEAPON_LEVEL_LIMIT)
    .integerValue()
    .toString(2)
  const helmetTypeStr = new BigNumber(helmetType)
    .mod(HELMET_TYPE_LIMIT)
    .integerValue()
    .toString(2)
  const helmetLevelStr = new BigNumber(helmetLevel)
    .mod(HELMET_LEVEL_LIMIT)
    .integerValue()
    .toString(2)
  const petTypeBinary = Array.from(Array(PET_FEATURES_LEN - petTypeStr.length).keys()).map(() => '0').join('') + petTypeStr
  const weaponTypeBinary = Array.from(Array(PET_FEATURES_LEN - weaponTypeStr.length).keys()).map(() => '0').join('') + weaponTypeStr
  const weaponLevelBinary = Array.from(Array(PET_FEATURES_LEN - weaponLevelStr.length).keys()).map(() => '0').join('') + weaponLevelStr
  const helmetTypeBinary = Array.from(Array(PET_FEATURES_LEN - helmetTypeStr.length).keys()).map(() => '0').join('') + helmetTypeStr
  const helmetLevelBinary = Array.from(Array(PET_FEATURES_LEN - helmetLevelStr.length).keys()).map(() => '0').join('') + helmetLevelStr

  return petTypeBinary +
    weaponTypeBinary +
    weaponLevelBinary +
    helmetTypeBinary +
    helmetLevelBinary +
    '0000000000000000.svg'
}

// Handle omission of wallet address
export function dealToken(address: any, replace: string) {
  if (address) {
    return address.substring(0, 13) + replace + address.substring(25, 42)
  }
  return '-'
}
// 深度拷贝
export const deepCopy = (obj: any) => {
  let target
  let result = obj
  let temp
  if (obj && ((temp = (obj instanceof Array)) || obj instanceof Object)) {
    result = temp ? [] : {}
    for (target in obj) {
      if (obj.hasOwnProperty(target)) {
        result[target] = deepCopy(obj[target])
      }
    }
  }
  return result
}

// 判断app访问还是pc
export const isPC = () => { 
  var userAgentInfo = navigator.userAgent 
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone','iPad', 'iPod'] 
  var flag = true 
  for (var v = 0; v < Agents.length; v++) { 
    if (userAgentInfo.indexOf(Agents[v]) > 0) { 
      flag = false 
      break 
    } 
  } 
  return flag 
}

export const GetQueryString = (name: string, search: string) => { 
  var reg: any = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = search.substr(1).match(reg) //获取url中"?"符后的字符串并正则匹配
  var context = '' 
  if (r != null) 
  context = r[2]
  reg = null
  r = null
  return context == null || context == '' || context == 'undefined' ? '' : context
}

export const windowSize = () => {
  return !process['browser']
    ? {
        w: 0,
        h: 0,
      }
    : {
        w: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        h: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
      }
}

export function getElementTop(el: any) {
  let actualTop = el.offsetTop
  let current = el.offsetParent
  while (current !== null) {
    actualTop += current.offsetTop
    current = current.offsetParent
  }
  return actualTop
}

export const splicingGetParams = (params: any | undefined) => {
  let param = ''
  if (params) {
    for (const key in params) {
      param += `${key}=${params[key]}&`
    }
  }
  param = param ? '?' + param.substring(0, param.length - 1) : ''

  return param
}

export const sessionStore = {
  get: (key: any) => {
    try {
      return JSON.parse(sessionStorage.getItem(key) + '')
    } catch (e) {
      sessionStorage.removeItem(key)
    }
  },
  set: (key: any, val: any) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(val))
    } catch (e) {
      const ev: any = e
      if (ev?.name === 'QuotaExceededError') {
        sessionStorage.removeItem(key)
      }
    }
  },
  remove: (key: any) => {
    sessionStorage.removeItem(key)
  },
  clear: () => {
    sessionStorage.clear()
  },
}
